import { makeEroadStyles } from "../../../styles";

const useStyles = makeEroadStyles(
  (theme) => ({
    wrapper: {
      display: "flex",
      flexWrap: "wrap",
      marginTop: theme.spacing(5),
      ...theme.typography.sizes.md,

      [`@media (max-width: ${theme.breakpoints.values.lg - 1}px)`]: {
        ...theme.typography.sizes.sm,
        justifyContent: "space-between",
      },
    },

    item: {
      alignItems: "center",
      display: "flex",
      padding: theme.spacing(1),
      "& > :first-child": {
        color: theme.colors.onsurfaceTechnicalFont,
      },
      [`@media (min-width: ${theme.breakpoints.values.lg}px)`]: {
        flexBasis: "25%",
      },
    },

    itemText: {
      marginLeft: theme.spacing(2),
      transform: "translateY(1px)",
    },
  }),
  { name: "PageInfo" }
);

export { useStyles };
